<!-- 首页 -->
<template>
  <div class="warp">
    <div class="bannerTop">
      <div class="banner">
        <img style="width:100%" src="../assets/images/index_banner.gif" />
      </div>
      <div class="tisList">
        <ul>
          <li>
            <span>9+</span>
            <p>年技术沉淀</p>
          </li>
          <li>
            <span>60+</span>
            <p>款创新产品</p>
          </li>
          <li>
            <span>50+</span>
            <p>人专业团队</p>
          </li>
          <li>
            <span>10000+</span>
            <p>家全球客户</p>
          </li>
        </ul>
      </div>
      <div class="bannerTis">
        <img src="../assets/images/index_icon01.gif" />
        <span>绿茶科技 为您专属定制</span>
      </div>
      <div class="indexItem">
        <div class="itemBorder">
          <div class="title">
            <p>
              专注内容变现的SAAS平台
              <b>学拾系统</b>
            </p>
            <span>
              10分钟入局内容变现，多样化变现形式
              <br />裂变式课程营销，丰富的推广方式
            </span>
          </div>
          <div class="imgBox">
            <img src="../assets/images/index_item01.png" />
          </div>
          <div class="list">
            <ul>
              <li>
                <span></span>
                <p>教育O2O</p>
              </li>
              <li>
                <span></span>
                <p>IM社交</p>
              </li>
              <li>
                <span></span>
                <p>知识付费</p>
              </li>
              <li>
                <span></span>
                <p>IM社社群营销</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="indexItem">
      <div class="itemBorder">
        <div class="title">
          <p>
            助力企业玩转花式营销
            <b>直播系统</b>
          </p>
          <span>
            全渠道精准引流，直播实时互动
            <br />用户智能化管理，数据驱动增值
          </span>
        </div>
        <div class="imgBox">
          <img src="../assets/images/index_item02.png" />
        </div>
        <div class="list">
          <ul>
            <li>
              <span></span>
              <p>直播+短视频</p>
            </li>
            <li>
              <span></span>
              <p>互动直播</p>
            </li>
            <li>
              <span></span>
              <p>短视频</p>
            </li>
            <li>
              <span></span>
              <p>短视频社交</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="indexItem">
      <div class="itemBorder">
        <div class="title">
          <p>
            人人都需要的开源网店系统
            <b>电商系统</b>
          </p>
          <span>
            结合不同应用场景业务特征形成产品，
            <br />满足企业在典型场景的系统需求
          </span>
        </div>
        <div class="imgBox">
          <img src="../assets/images/index_item03.png" />
        </div>
        <div class="list">
          <ul>
            <li>
              <span></span>
              <p>会员制社交</p>
            </li>
            <li>
              <span></span>
              <p>分享型社交</p>
            </li>
            <li>
              <span></span>
              <p>拼购类社交</p>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="indexItem">
      <div class="itemBorder">
        <div class="title">
          <p>
            给企业精细化营销插上翅膀
            <b>营销插件</b>
          </p>
          <span>
            上百个功能插件满足不同企业不同营销需求，
            <br />实现裂变式推广效果
          </span>
        </div>
        <div class="imgBox">
          <img src="../assets/images/index_item04.png" />
        </div>
        <div class="btns" @click="toLinkCom('marketing')">了解详情</div>
      </div>
    </div>
    <div class="swiperBox">
      <swiper :options="swiperOption" class="swiper-container">
        <!-- slides -->
        <swiper-slide class="swiper-item" v-for="(item,index) of swiperList" :key="index">
          <div class="box">
            <img class="swiper-img" :src="item.imgUrl" alt="去哪儿门票" />
          </div>
        </swiper-slide>
        <!-- Optional controls ,显示小点-->
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="invite">
      <swiper :options="swiperInvite">
        <swiper-slide class="swiper-item" v-for="(item,index) of swiperText" :key="index">
          <span>{{item.span}}</span>
          <p>{{item.p}}</p>
          <button type="button" @click="toService">微信客服</button>
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="section">
      <div class="indexTtile">
        <span>齐心协力，共创未来</span>
        <p>战略伙伴</p>
      </div>
      <div class="link">
        <ul>
          <li v-for="(data,index) in customerList" :key="index">
            <span>
              <img :src=" url + data.imgUrl " />
            </span>
          </li>
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link01.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link02.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link03.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link04.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link01.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link02.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link03.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link04.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link01.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link02.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link03.png"/>-->
          <!--                    </li>-->
          <!--                    <li>-->
          <!--                        <img src="../assets/images/link04.png"/>-->
          <!--                    </li>-->
        </ul>
      </div>
    </div>

    <div class="section">
      <div class="indexTtile">
        <span>品质服务，信任之选</span>
        <p>面向全国</p>
        <h6>10000+ 服务商&nbsp;&nbsp;&nbsp;&nbsp;120+ 城市</h6>
      </div>
      <div class="global">
        <img src="../assets/images/index_item05.png" />
      </div>
    </div>

    <div class="section">
      <div class="indexTtile">
        <span>实时掌握绿茶最新动态</span>
        <p>新闻中心</p>
      </div>
      <div class="new">
        <div class="item">
          <div class="title">
            <span>
              <img src="../assets/images/index_new02.png" />公司快讯
            </span>
            <p @click="toNewList(1)">
              查看更多
              <img src="../assets/images/index_new01.png" />
            </p>
          </div>
          <div class="con">
            <div v-for="(data,index) in typeOne.slice(0,3)" :key="index" @click="toNewProduct(data,1)">
              <span>{{data.createTime | formatDate}}{{' '}}{{data.title}}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="title">
            <span>
              <img src="../assets/images/index_new03.png" />产品动态
            </span>
            <p @click="toNewList(2)">
              查看更多
              <img src="../assets/images/index_new01.png" />
            </p>
          </div>
          <div class="con">
            <div v-for="(data,index) in typeTwo.slice(0,3)" :key="index" @click="toNewProduct(data,2)">
              <span>{{data.createTime | formatDate}}{{' '}}{{data.title}}</span>
            </div>
          </div>
        </div>
        <div class="item">
          <div class="title">
            <span>
              <img src="../assets/images/index_new04.png" />行业动态
            </span>
            <p @click="toNewList(3)">
              查看更多
              <img src="../assets/images/index_new01.png" />
            </p>
          </div>
          <div class="con">
            <div v-for="(data,index) in typeTree.slice(0,3)" :key="index" @click="toNewProduct(data,3)">
              <span>{{data.createTime | formatDate}}{{' '}}{{data.title}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

moment.locale("zh-cn");
import { bannerList, customer, getNews } from "@/api/other.js";
import config from "../../config/config";
export default {
  name: "index",
  filters: {
    formatDate(time) {
      let date = new Date(time);
      return moment(date).format("MM/DD");
    },
  },
  data() {
    return {
      url: config.baseUrl.pro,
      typeOne: [],
      typeTwo: [],
      typeTree: [],
      swiperOption: {
        loop: true,
        speed: 1000, //匀速时间
        autoplay: {
          delay: 0,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        slidesPerView: 4,
        centeredSlides: true,
      },

      swiperList: [
        { imgUrl: require("../assets/images/logo01.png") },
        { imgUrl: require("../assets/images/logo02.png") },
        { imgUrl: require("../assets/images/logo03.png") },
        { imgUrl: require("../assets/images/logo04.png") },
        { imgUrl: require("../assets/images/logo05.png") },
        { imgUrl: require("../assets/images/logo06.png") },
      ],

      swiperText: [
        {
          span: "信任源于专业，做为公共部门我们的选择都会比较谨慎，但经过和绿茶科技的接触与合作，我们更加坚信我们找对了一个最佳合作伙伴。",
          p: "by : 铜山人大",
        },
        {
          span: "信任源于专业，做为公共部门我们的选择都会比较谨慎，但经过和绿茶科技的接触与合作，我们更加坚信我们找对了一个最佳合作伙伴。",
          p: "by : 铜山人大",
        },
        {
          span: "信任源于专业，做为公共部门我们的选择都会比较谨慎，但经过和绿茶科技的接触与合作，我们更加坚信我们找对了一个最佳合作伙伴。",
          p: "by : 铜山人大",
        },
        {
          span: "信任源于专业，做为公共部门我们的选择都会比较谨慎，但经过和绿茶科技的接触与合作，我们更加坚信我们找对了一个最佳合作伙伴。",
          p: "by : 铜山人大",
        },
      ],
      swiperInvite: {
        loop: true,
        speed: 500, //匀速时间
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },

        centeredSlides: true,
      },
      customerList: [],
    };
  },
  mounted() {},

  created() {
    this.getBannerList();
    this.getCustomerList();
    this.getTypeOne();
    this.getTypeTwo();
    this.getTypeThree();
  },
  methods: {
    toService(){
      window.location.href="https://work.weixin.qq.com/kfid/kfc4a1a89c3395408e9"
    },
    toNewProduct(item, active) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$router.push({
        name: "newProduct",
        query: { id: item.id, active: active },
      });
    },

    toLinkCom(name) {
      let vm = this;
      vm.$router.push({ name: name });
      vm.showNav = false;
      vm.newNav = 2;
      window.scrollTo(0, 0);
    },

    toNewList(active) {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
      this.$router.push({
        name: "newList",
        params: { active: active },
      });
    },
    /**
     * 轮播图获取
     */
    getBannerList() {
      this.swiperText = [];
      bannerList()
        .then((res) => {
          res.data.map((item) => {
            this.swiperText.push({
              img: this.url + item.imgUrl,
              p: item.text,
              span: item.author,
            });
          });
        })
        .catch((err) => {
          // this.$Message.error(err);
        });
    },
    /**
     * 获取
     */
    getCustomerList() {
      customer()
        .then((res) => {
          this.customerList = res;
        })
        .catch((err) => {
          // this.$Message.error(err);
        });
    },
    /**
     * 获取新闻数据
     */
    getTypeOne() {
      getNews({ type: 1 })
        .then((res) => {
          this.typeOne = res;
        })
        .catch((err) => {
          // this.$Message.error(err);
        });
    },
    /**
     * 获取新闻数据
     */
    getTypeTwo() {
      getNews({ type: 2 })
        .then((res) => {
          this.typeTwo = res;
        })
        .catch((err) => {
          // this.$Message.error(err);
        });
    },
    /**
     * 获取新闻数据
     */
    getTypeThree() {
      getNews({ type: 3 })
        .then((res) => {
          this.typeTree = res;
        })
        .catch((err) => {
          // this.$Message.error(err);
        });
    },
  },
};
</script>
<style lang='less' scoped>
.warp {
  background-color: #ecedf0;
  padding-top: 1.45rem;
  box-sizing: border-box;
  padding-bottom: 1.2rem;

  .bannerTop {
    background-color: #fff;

    .tisList {
      padding: 0 0.4rem;

      ul {
        background-color: #fff;
        box-shadow: 0px 0 0.45rem 0px rgba(29, 97, 47, 0.2);
        border-radius: 0.2rem;
        height: 2.3rem;
        display: flex;
        position: relative;
        z-index: 99;
        margin-top: -0.4rem;

        li {
          flex: 1;
          text-align: center;

          span {
            font-size: 0.5rem;
            font-weight: bold;
            font-family: Arial, Helvetica, sans-serif;
            line-height: 1.2rem;
            padding-top: 0.2rem;
            display: block;
          }

          p {
            font-size: 0.32rem;
            color: #666;
          }
        }
      }
    }

    .bannerTis {
      text-align: center;
      padding-top: 0.7rem;
      padding-bottom: 0.2rem;

      span {
        font-size: 0.32rem;
        font-weight: 300;
      }

      img {
        width: 0.44rem;
        margin-top: -0.08rem;
        margin-right: 0.1rem;
      }
    }
  }

  .indexItem {
    background-color: #fff;
    padding: 0.1rem 0.38rem 0.1rem;
    margin-bottom: 0.3rem;

    .itemBorder {
      border: 1px solid #f4f4f4;
      border-radius: 0.1rem;
      padding: 1rem 0 0.6rem;
      text-align: center;

      .title {
        p {
          font-size: 0.5rem;
          height: 0.6rem;
          line-height: 0.6rem;

          b {
            font-size: 0.6rem;
          }
        }

        span {
          font-size: 0.36rem;
          color: #919193;
          line-height: 0.6rem;
          padding-top: 0.3rem;
          display: block;
        }
      }

      .imgBox {
        padding: 0.2rem 0;

        img {
          height: 6.3rem;
        }
      }

      .list {
        ul {
          display: inline-block;
          background-color: #e9f6f1;
          line-height: 0.75rem;
          height: 0.75rem;
          padding: 0 0.4rem;
          border-radius: 0.75rem;

          li {
            display: inline-block;
            padding: 0 0.15rem;

            p {
              font-size: 0.32rem;
              color: #262e43;
              display: inline-block;
              vertical-align: middle;
            }

            span {
              width: 0.14rem;
              height: 0.14rem;
              border-radius: 0.14rem;
              background-color: #5ece7a;
              display: inline-block;
              margin-right: 0.15rem;
              vertical-align: middle;
            }
          }
        }
      }

      .btns {
        width: 3rem;
        height: 0.8rem;
        border-radius: 1rem;
        border: 1px solid #4bb274;
        color: #4bb274;
        font-size: 0.34rem;
        line-height: 0.8rem;
        margin: auto;
      }
    }
  }

  .swiperBox {
    padding: 0.2rem 0;
    overflow: hidden;

    .swiper-container {
      width: 120%;

      .swiper-wrapper {
        width: 100%;

        .swiper-item {
          padding: 0.4rem 0;

          .box {
            width: 2.7rem;
            height: 2.7rem;
            box-shadow: 0px 0.16rem 0.4rem 0px rgba(146, 152, 158, 0.4);
            border-radius: 0.1rem;
            background-color: #fff;
            display: flex;
            align-items: center;
            padding: 0.3rem;
            box-sizing: border-box;
          }
        }
      }
    }
  }

  .invite {
    padding: 0.3rem 0.4rem;

    .swiper-container {
      height: 7rem;
      background: url("../assets/images/index_invite.png") no-repeat left bottom
        #52c77b;
      background-size: 100% auto;
      border-radius: 0.2rem 0.2rem 0 0;

      .swiper-wrapper {
        width: 10rem;
        height: 100%;

        .swiper-item {
          padding: 0.7rem 1.4rem 0 1rem;
          box-sizing: border-box;

          span {
            font-size: 0.34rem;
            color: #fff;
            line-height: 0.6rem;
          }

          p {
            font-size: 0.26rem;
            color: #fff;
            padding: 0.6rem 0;
          }

          button {
            width: 3rem;
            line-height: 0.8rem;
            border-radius: 0.8rem;
            border: 1px solid #fff;
            color: #fff;
            margin: auto;
            display: block;
          }
        }
      }
    }
  }

  .section {
    padding: 1.25rem 0.4rem 0 0.4rem;

    .indexTtile {
      text-align: center;

      span {
        font-size: 0.5rem;
      }

      p {
        font-size: 0.6rem;
        padding: 0.2rem 0;
      }

      h6 {
        font-size: 0.34rem;
        color: #41a787;
        padding-top: 0.2rem;

        b {
          font-size: 0.36rem;
        }
      }
    }

    .link {
      background-color: #fff;
      border-radius: 0.2rem;
      margin-top: 0.4rem;

      ul {
        display: flex;
        align-items: center;
        // justify-content: space-between;
        flex-direction: row;
        flex-wrap: wrap;
        padding: 0.4rem 0.2rem;

        li {
          width: 25%;
          padding: 0.2rem 0;
        }
      }
    }

    .new {
      padding-top: 0.6rem;

      .item {
        border-radius: 0.2rem;
        background-color: #fff;
        margin-bottom: 0.4rem;
        overflow: hidden;

        .title {
          padding: 0 0.2rem 0 0.5rem;
          display: flex;
          line-height: 1.2rem;
          align-items: center;
          border-bottom: 1px solid #e5e5e5;

          img {
            width: 0.5rem;
            margin-top: -0.08rem;
          }

          span {
            flex: 1;
            font-size: 0.4rem;

            img {
              margin-right: 0.2rem;
            }
          }

          p {
            color: #666;
            font-size: 0.32rem;
          }
        }

        .con {
          line-height: 0.8rem;
          font-size: 0.34rem;
          padding: 0.3rem 0.6rem;

          span {
            display: block;
            height: 0.8rem;
            color: #666;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue